import React from "react";
import { render, unmountComponentAtNode } from "react-dom";
import { Loader, Toast, Fallback, ErrorBoundary } from "@sicredi/react";
import "./global.scss";
import App from "#/containers/App";
import { startApiMockServer } from "#/api/server";
import { onResponse } from "#/utils/request";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const ROOT = document.getElementById("root")!;

function unmountRender(element: React.ReactElement) {
  unmountComponentAtNode(ROOT);
  render(element, ROOT);
}

unmountRender(<Loader show fullScreen />);

if (!!process.env.REACT_APP_MIRAGE && process.env.REACT_APP_MIRAGE === "true") {
  startApiMockServer({});
}

onResponse((response) => {
  function handleClose() {
    window.auth.actions.logout();
    window.location.reload();
  }

  if (response?.status === 401) {
    unmountRender(
      <Fallback title="Acesso negado" onClose={handleClose}>
        Você não possui autorização para acessar essa aplicação.
      </Fallback>
    );
  }
});

unmountRender(
  <ErrorBoundary onClose={() => window.location.reload()} onReset={() => window.location.reload()}>
    <Toast />
    <App />
  </ErrorBoundary>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
